import React from "react";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import { Freeze_Unfreeze } from "../../Configuration/API_URL";
import axios from "axios";

function FreezeUnfreezeStatus(prop) {
  const { setModalState, modalData, setPageStatus, qaeRes, data, freezStatus } =
    prop;

  const UpdateFreezUnfreezStatus = async () => {
    let freezeUpdatePayload = {
      mobile: localStorage.getItem("mobile"),
      pan: localStorage.getItem("pan"),
      freeze: !freezStatus,
    };
    let encPayload = AESEncryption(freezeUpdatePayload);
    try {
      const responseData = await axios.post(
        Freeze_Unfreeze.UpdateFreezUnfreezStatus,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(responseData?.data);
      if (res?.status === 0) {
        setModalState({
          modal: true,
          data: modalData.requestFreezeAccountSubmitted,
          onPrimaryClick: NavigatetoStart,
        });
        // setPageStatus("user")
      } else {
        if (
          res.message ==
          "Your request for freeze is already in process. Please try again later"
        ) {
          setModalState({ modal: true, data: modalData.alreadyProcess });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const NavigatetoStart = () => {
    setPageStatus("user");
  };
  return (
    <div className="card-box validateUserWrapper freezeStatus">
      <div className="card-title">
        <h2 className="h2-css-all">
          {freezStatus ? "Unfreeze" : "Freeze"} Account
        </h2>
        <div className="status-right-section">
          <h6>Current Account Status:</h6>
          <div className="status-block">
            {freezStatus ? "Frozen" : "Unfrozen"}
          </div>
        </div>
      </div>
      <div className="card-contnent">
        <div className="row">
          {freezStatus ? (
            <ul className="ul-data">
              <li>1. Enable Fund Transfers</li>
              <li>2. Enable modification of default Bank and User details</li>
            </ul>
          ) : (
            <ul className="ul-data">
              <li>1. Cancel all online pending orders</li>
              <li>2. Block Fund Transfers</li>
              <li>3. Block modification of default Bank and User details</li>
              <li>4. Force Logout from all devices</li>
            </ul>
          )}
        </div>

        <div className="validate-skip-btn">
          <div className="">
            <button
              type="button"
              className="skip-btn mr-5"
              onClick={() => {
                setModalState({
                  modal: true,
                  data: modalData.cancelRequest,
                  onPrimaryClick: NavigatetoStart,
                });
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="validate-btn mr-0"
              onClick={() => {
                // UpdateFreezUnfreezStatus()
                setModalState({
                  modal: true,
                  data: modalData.sureToFreezeAccount,
                  onPrimaryClick: UpdateFreezUnfreezStatus,
                });
                // setPageStatus("user");
              }}
            >
              {freezStatus ? "Unfreeze" : "Freeze"} Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FreezeUnfreezeStatus;
